import React from "react";
import { Route, Redirect } from "react-router-dom";
import Layout from "../components/layout";
import { getJsonCookies, getCookie } from '../helpers/utility.js'

const PublicRoute = ({ component: Component, layoutSettings = {}, ...rest }) => (
    <Route
        {...rest}
        render={props =>
            // <Layout settings={layoutSettings} >
            <Component {...props} />
            // </Layout>
        }
    />
);

const RestrictedRoute = ({ component: Component, layoutSettings = {}, ...rest }) => (
    <Route
        {...rest}
        render={props => {
            return (
                getJsonCookies() ? (
                    <Layout settings={{ ...layoutSettings, showScrollUp: true }}>
                        <Component {...props} settings={layoutSettings} />
                    </Layout>
                ) : (
                    <Redirect
                        to={{
                            pathname: "/login",
                            state: { from: props.location }
                        }}
                    />
                )
            )
        }
        }
    />
);

const UnRestrictedRoute = ({ component: Component, layoutSettings = {}, ...rest }) => (
    <Route
        {...rest}
        render={props => {
            let cookie = getCookie()
            let businessData = JSON.parse(localStorage.getItem('businessData'));
            if (cookie && cookie.token && businessData && businessData.bname) {
                return (<Redirect
                    to={{
                        pathname: `${businessData.bname.toLowerCase().replace(/[^a-z0-9]/g, '-')}/payment`,
                        state: { from: props.location }
                    }}
                />)
            }

            if (cookie && cookie.token) {
                // return (<Redirect
                //     to={{
                //         pathname: `/payment`,
                //         state: { from: props.location }
                //     }}
                // />)
            }

            return (
                <Layout settings={{ ...layoutSettings }}>
                    <Component {...props} settings={layoutSettings} />
                </Layout>
            )
        }}
    />
);

export { RestrictedRoute, UnRestrictedRoute, PublicRoute }